Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.setSuggestionsSearchValue = setSuggestionsSearchValue;
exports.clearSuggestionsSearchValue = clearSuggestionsSearchValue;
exports.updateAnalyticsConfig = updateAnalyticsConfig;
exports.getRecentSearches = getRecentSearches;
exports.recordResultClick = recordResultClick;
exports.recordSuggestionClick = recordSuggestionClick;
exports.recordImpressions = recordImpressions;

var _constants = require('../constants');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function setSuggestionsSearchValue(value) {
  return {
    type: _constants.SET_SUGGESTIONS_SEARCH_VALUE,
    value: value
  };
}

function clearSuggestionsSearchValue() {
  return {
    type: _constants.CLEAR_SUGGESTIONS_SEARCH_VALUE
  };
}

function updateAnalyticsConfig(analyticsConfig) {
  return {
    type: _constants.UPDATE_ANALYTICS_CONFIG,
    analyticsConfig: analyticsConfig
  };
}

function getRecentSearches() {
  var queryOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    size: 5,
    minChars: 3
  };
  return function (dispatch, getState) {
    var _getState = getState(),
        config = _getState.config,
        headers = _getState.headers,
        _getState$appbaseRef = _getState.appbaseRef,
        url = _getState$appbaseRef.url,
        protocol = _getState$appbaseRef.protocol,
        credentials = _getState$appbaseRef.credentials;

    var app = config.app,
        mongodb = config.mongodb;
    var esURL = protocol + '://' + url;
    var parsedURL = (esURL || '').replace(/\/+$/, '');
    var requestOptions = {
      headers: _extends({}, headers, {
        'Content-Type': 'application/json',
        Authorization: 'Basic ' + btoa(credentials)
      })
    };
    var queryString = '';

    var addParam = function addParam(key, value) {
      if (queryString) {
        queryString += '&' + key + '=' + value;
      } else {
        queryString += key + '=' + value;
      }
    };

    if (config.analyticsConfig && config.analyticsConfig.userId) {
      addParam('user_id', config.analyticsConfig.userId);
    }

    if (queryOptions) {
      if (queryOptions.size) {
        addParam('size', String(queryOptions.size));
      }

      if (queryOptions.from) {
        addParam('from', queryOptions.from);
      }

      if (queryOptions.to) {
        addParam('to', queryOptions.to);
      }

      if (queryOptions.minChars) {
        addParam('min_chars', String(queryOptions.minChars));
      }

      if (queryOptions.customEvents) {
        Object.keys(queryOptions.customEvents).forEach(function (key) {
          addParam(key, queryOptions.customEvents[key]);
        });
      }
    }

    if (mongodb) {
      return dispatch({
        type: _constants.RECENT_SEARCHES_SUCCESS,
        data: []
      });
    }

    return fetch(parsedURL + '/_analytics/' + app + '/recent-searches?' + queryString, requestOptions).then(function (res) {
      if (res.status >= 500 || res.status >= 400) {
        return dispatch({
          type: _constants.RECENT_SEARCHES_ERROR,
          error: res
        });
      }

      return res.json().then(function (recentSearches) {
        return dispatch({
          type: _constants.RECENT_SEARCHES_SUCCESS,
          data: recentSearches
        });
      }).catch(function (e) {
        return dispatch({
          type: _constants.RECENT_SEARCHES_ERROR,
          error: e
        });
      });
    }).catch(function (e) {
      return dispatch({
        type: _constants.RECENT_SEARCHES_ERROR,
        error: e
      });
    });
  };
}

function recordClick(_ref) {
  var documentId = _ref.documentId,
      clickPosition = _ref.clickPosition,
      analyticsInstance = _ref.analyticsInstance,
      isSuggestionClick = _ref.isSuggestionClick;

  if (!documentId) {
    console.warn('ReactiveSearch: document id is required to record the click analytics');
  } else {
    analyticsInstance.click({
      queryID: analyticsInstance.getQueryID(),
      objects: _defineProperty({}, documentId, clickPosition + 1),
      isSuggestionClick: isSuggestionClick
    });
  }
}

function recordResultClick(searchPosition, documentId) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        config = _getState2.config,
        searchId = _getState2.analytics.searchId,
        headers = _getState2.headers,
        _getState2$appbaseRef = _getState2.appbaseRef,
        url = _getState2$appbaseRef.url,
        protocol = _getState2$appbaseRef.protocol,
        credentials = _getState2$appbaseRef.credentials,
        analyticsInstance = _getState2.analyticsRef;

    var app = config.app;
    var esURL = protocol + '://' + url;

    if (config.analytics && searchId) {
      var parsedHeaders = headers;
      delete parsedHeaders['X-Search-Query'];
      var parsedURL = (esURL || '').replace(/\/+$/, '');

      if (parsedURL.includes('scalr.api.appbase.io')) {
        fetch(parsedURL + '/' + app + '/_analytics', {
          method: 'POST',
          headers: _extends({}, parsedHeaders, {
            'Content-Type': 'application/json',
            Authorization: 'Basic ' + btoa(credentials),
            'X-Search-Id': searchId,
            'X-Search-Click': true,
            'X-Search-ClickPosition': searchPosition + 1
          })
        });
      } else {
        recordClick({
          documentId: documentId,
          clickPosition: searchPosition,
          analyticsInstance: analyticsInstance
        });
      }
    }
  };
}

function recordSuggestionClick(searchPosition, documentId) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        config = _getState3.config,
        suggestionsSearchId = _getState3.analytics.suggestionsSearchId,
        headers = _getState3.headers,
        _getState3$appbaseRef = _getState3.appbaseRef,
        url = _getState3$appbaseRef.url,
        protocol = _getState3$appbaseRef.protocol,
        credentials = _getState3$appbaseRef.credentials,
        analyticsInstance = _getState3.analyticsRef;

    var app = config.app;
    var esURL = protocol + '://' + url;

    if (config.analytics && (config.analyticsConfig === undefined || config.analyticsConfig.suggestionAnalytics === undefined || config.analyticsConfig.suggestionAnalytics)) {
      var parsedHeaders = headers;
      delete parsedHeaders['X-Search-Query'];
      var parsedURL = (esURL || '').replace(/\/+$/, '');

      if (parsedURL.includes('scalr.api.appbase.io') && searchPosition !== undefined && suggestionsSearchId) {
        fetch(parsedURL + '/' + app + '/_analytics', {
          method: 'POST',
          headers: _extends({}, parsedHeaders, {
            'Content-Type': 'application/json',
            Authorization: 'Basic ' + btoa(credentials),
            'X-Search-Id': suggestionsSearchId,
            'X-Search-Suggestions-Click': true,
            'X-Search-Suggestions-ClickPosition': searchPosition + 1
          })
        });
      } else if (searchPosition !== undefined) {
        recordClick({
          documentId: documentId,
          clickPosition: searchPosition,
          analyticsInstance: analyticsInstance,
          isSuggestionClick: true
        });
      }
    }
  };
}

function recordImpressions(queryId) {
  var impressions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (dispatch, getState) {
    var _getState4 = getState(),
        _getState4$appbaseRef = _getState4.appbaseRef,
        url = _getState4$appbaseRef.url,
        protocol = _getState4$appbaseRef.protocol,
        analyticsInstance = _getState4.analyticsRef,
        config = _getState4.config;

    var esURL = protocol + '://' + url;
    var parsedURL = esURL.replace(/\/+$/, '');

    if (config.analytics && !parsedURL.includes('scalr.api.appbase.io') && queryId && impressions.length) {
      analyticsInstance.search({
        queryID: analyticsInstance.getQueryID(),
        impressions: impressions
      });
    }
  };
}